import React from 'react';
import PillBadge from './PillBadge';

export default function IntegrationRow({ icon, name, description, connected, loading, onConnect, onDisconnect }) {
  return (
    <div style={styles.row}>
      {icon && <span style={styles.icon} aria-hidden>{icon}</span>}
      <div style={styles.body}>
        <div style={styles.titleRow}>
          <span style={styles.name}>{name}</span>
          {!loading && (
            connected
              ? <PillBadge label="✓ Connecté" variant="success" />
              : <PillBadge label="Non connecté" variant="default" />
          )}
        </div>
        {description && <p style={styles.description}>{description}</p>}

        <div style={styles.actions}>
          {connected ? (
            <button type="button" onClick={onDisconnect} style={styles.linkBtn}>
              Déconnecter
            </button>
          ) : (
            <button type="button" onClick={onConnect} style={styles.connectBtn} disabled={loading}>
              {loading ? 'Chargement…' : 'Connecter →'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    padding: '14px 16px',
  },
  icon: {
    fontSize: 22,
    width: 40,
    height: 40,
    background: '#FFF5F0',
    borderRadius: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  name: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1A1A1A',
  },
  description: {
    margin: 0,
    fontSize: 13,
    color: '#6B6B6B',
    lineHeight: 1.4,
  },
  actions: {
    display: 'flex',
    gap: 8,
    marginTop: 4,
  },
  connectBtn: {
    background: '#E8502A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 999,
    padding: '8px 14px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  linkBtn: {
    background: 'transparent',
    border: 'none',
    color: '#6B6B6B',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    padding: 4,
    fontFamily: 'inherit',
  },
};
